import { http } from "@/utils/http";
import type { University, UniversityDto } from "@/types";

// API Response wrapper type
interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const universitiesApi = {
  // Get university list
  async getUniversities(): Promise<University[]> {
    const response = await http.get<ApiResponse<University[]>>("/api/v1/universities");
    return response.data.data; // Extract data from ApiResponse wrapper
  },

  // Get all universities (alias for getUniversities)
  async getAll(): Promise<{ data: University[] }> {
    const data = await this.getUniversities();
    return { data };
  },

  // Get university details
  async getUniversity(id: number): Promise<University> {
    const response = await http.get<ApiResponse<University>>(`/api/v1/universities/${id}`);
    return response.data.data; // Extract data from ApiResponse wrapper
  },

  // Create university
  async createUniversity(universityData: UniversityDto): Promise<University> {
    const response = await http.post<ApiResponse<University>>(
      "/api/v1/universities",
      universityData,
    );
    return response.data.data; // Extract data from ApiResponse wrapper
  },

  // Update university
  async updateUniversity(
    id: number,
    universityData: UniversityDto,
  ): Promise<University> {
    const response = await http.put<ApiResponse<University>>(
      `/api/v1/universities/${id}`,
      universityData,
    );
    return response.data.data; // Extract data from ApiResponse wrapper
  },

  // Delete university
  async deleteUniversity(id: number): Promise<void> {
    await http.delete(`/api/v1/universities/${id}`);
  },
};
